/**
 * Componente para o header do input de chave NFe
 */

"use client";
import { Label, Badge, Switch, Tooltiper } from "visuais";
import { IconReceiptDollarFilled } from "@tabler/icons-react";
import { identificacaoUtils } from "../../_utils";

interface ChaveInputHeaderProps {
  inputValue: string;
  xmlData: any;
  isAdmin: boolean;
  validarInclusao: boolean;
  onValidarInclusaoChange: (checked: boolean) => void;
}

export function ChaveInputHeader({
  inputValue,
  xmlData,
  isAdmin,
  validarInclusao,
  onValidarInclusaoChange,
}: ChaveInputHeaderProps) {
  // Detecta o tipo de documento
  const tipoDocumento =
    identificacaoUtils.xml.detectTypeByData(xmlData) ||
    identificacaoUtils.xml.detectTypeByKey(inputValue);

  return (
    <div className="flex items-center justify-between">
      <Label className="text-xs font-medium text-muted-foreground flex gap-1 items-center">
        <IconReceiptDollarFilled className="size-4 text-cyan-700 dark:text-cyan-400" />
        <span>Chave da NF</span>
        {tipoDocumento && (
          <Badge
            variant="secondary"
            className={`text-xs px-2 py-0.5 ${tipoDocumento.cor} border-0`}
          >
            <tipoDocumento.icon className="h-2.5 w-2.5 mr-1" />
            {tipoDocumento.tipo}
          </Badge>
        )}
      </Label>
      {isAdmin && (
        <Tooltiper content="Verificar duplicação" variant="default">
          <div className="flex items-center gap-2">
            <Switch
              id="validar-inclusao"
              checked={validarInclusao}
              onCheckedChange={onValidarInclusaoChange}
              className="scale-75"
              aria-label="Validar se já foi incluída"
            />
          </div>
        </Tooltiper>
      )}
    </div>
  );
}
